@if (isLoading) {
  <div class="ghost-elt widget-ghost">
    <div class="ghost-rect widget-ghost-rect"></div>
  </div>
}

<!-- count / list toggle: shown in the card header when hosted by a dashboard card, else here -->
<ng-template #headerActions>
  <div class="fav-grid-buttons" [class.in-frame]="headerActionsInFrame" [hidden]="isLoading">
    <div class="fav-grid-buttons-container" role="group">
      @if (widget?.aggregateColumnId) {
      <button
        type="button"
        [ngClass]="['fav-grid-button', activeView === 'CVT' ? 'active' : '']"
        [attr.aria-pressed]="activeView === 'CVT'"
        (click)="switchTo('CVT')">
        {{ 'favGrid.count' | translate }}
      </button>
      }
      <button
        type="button"
        [ngClass]="['fav-grid-button', activeView === 'LVT' ? 'active' : '']"
        [attr.aria-pressed]="activeView === 'LVT'"
        (click)="switchTo('LVT')">
        {{ 'favGrid.list' | translate }}
      </button>
    </div>
  </div>
</ng-template>
@if (!headerActionsInFrame) {
  <ng-container [ngTemplateOutlet]="headerActions" />
}

@if (noAccess && !isLoading) {
  <iu-widget-state class="no-data" state="noAccess" />
} @else if (loadError && !isLoading) {
  <iu-widget-state class="no-data" state="error" (retry)="retryLoad()" />
} @else if (activeView === 'LVT' && !isLoading && !isFetching && items$ && (items$ | async)?.length === 0) {
  <iu-widget-state class="no-data" state="noData" />
}

<div
  #fgiListElt
  class="fav-grid-items"
  [ngStyle]="{ display: isLoading || noAccess ? 'none' : activeView === 'LVT' ? 'flex' : 'none' }">
  @if (activeView === 'LVT') {
    <cdk-virtual-scroll-viewport class="fav-grid-virtualScroll" itemSize="40" [maxBufferPx]="240" [minBufferPx]="240">
      <div
        *cdkVirtualFor="let item of items$ | async; trackBy: trackByFn"
        class="fav-grid-item"
        (click)="openTab($event, item)">
        {{ item.displayedName }}
      </div>
    </cdk-virtual-scroll-viewport>
  }
</div>

@if (activeView === 'CVT' && !loadError && !noAccess) {
  <button
    #widgetCircularProgress
    type="button"
    class="circular-progress"
    [attr.aria-label]="(widget?.name ?? '') + ': ' + display(result, lang)"
    data-cy="openInWindow"
    [life]="3000"
    [hidden]="isLoading"
    pTooltip="{{ widget.alertLevel || widget.normalLevel ? display(result, lang) + ' - ' + percent + ' %' : display(result, lang) }}"
    (click)="openTab($event)">
    <span class="progress-value">
      <span [style.color]="bgColor">
        {{ display(displayedResult, lang) }}
      </span>
    </span>
  </button>
}
